import FeedbackResponseView from './FeedbackResponseView';
export default { FeedbackResponseView };
